import { useStandaloneMode } from "@/hooks/useStandaloneMode";
import Menubar from "./MenuBar";
import { getIOSVersion } from "@/lib/utils";

export default function TabBar() {
  const isStandalone = useStandaloneMode();
  const iosVersion = getIOSVersion();

  const detachingBarIosVersions = ["26.0"];

  const versionString = iosVersion
    ? `${iosVersion.major}.${iosVersion.minor}`
    : null;

  if (versionString && detachingBarIosVersions.includes(versionString)) {
    return (
      <div
        className={`md:hidden w-[75vw] sm:w-[70vw] !fixed ${
          isStandalone ? "!bottom-7" : "!bottom-2"
        } inset-x-0 mx-auto bg-white/20 backdrop-blur-md px-[6vw] z-20 pointer-events-auto rounded-full border border-zinc-100/20`}
      >
        <Menubar darkButtons={true} />
      </div>
    );
  }

  return (
    <div
      className="md:hidden !fixed !bottom-0 !left-0 !right-0 bg-black px-6 border-t-[#303030] border-t z-20 pb-[calc(env(safe-area-inset-bottom)+0.25rem)]"
    >
      <Menubar />
    </div>
  );
}
